// extracted by mini-css-extract-plugin
export default {"wrapper":"_b","body":"ac","cta":"bc","heading":"cc","blinking":"dc","gradientShift":"ec","float":"fc","move":"gc","scroll":"hc"};